import { AfterViewInit, ChangeDetectorRef, Component, ComponentFactoryResolver, ElementRef, OnDestroy, OnInit, QueryList, ViewChild, ViewChildren, ViewContainerRef } from '@angular/core';
import { CtrlBaseComponent } from '../ctrl-base.component';
import { Action, ApiResponseModel, OtpModel, OtpNotificationModel, TwoFactorAuthentication } from '../../models';
import { CtMessageSize, CtMessageStyle, CtMessageType, CtMessageVisualization } from '../../enums/plusMessage';
import { OtpType } from '../../enums/otp.enum';
import { CtButtonComponent } from '../ct-button/ct-button.component';
import { CtRadioComponent } from '../ct-radio/ct-radio.component';
import { CtInputTextComponent } from '../ct-input-text/ct-input-text.component';

const radioComponent : any = {
    ctType: "CtRadio",
    controlProperties: {
      hidden: false,
      listenedComponentId: "",
      listenedProperty: "",
      border: false,
      isChecked: false,
      readOnly: false,
      labelValue: '',
      value: '',
      descriptionValue: "",
      familyValue: "otpUserContactType",
      id: `MFA_LOGIN_CONTACTS_`,
      modelId: ""
    },
    controlActions: [
    ],
    models: []
}

const buttonComponent : any = {
  ctType: 'CtButton',
  controlProperties: {  
    hidden : false,
    listenedComponentId: "",
    listenedProperty: "",
    disabled: false,
    modelId: "",
    btnBlock: true,
    buttonText: 'SOLICITAR CÓDIGO',
    buttonColor: 'Primary',
    icon: "",
    id: `GENERAR_SOL_COD_OTP`,
  },
  controlActions: [],
  models: []
}

@Component({
  selector: 'lib-ct-otp',
  templateUrl: './ct-otp.component.html',
  styleUrls: ['./ct-otp.component.css']
})
export class CtOtpComponent extends CtrlBaseComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('errorMessageContainer', { read: ViewContainerRef }) messageContainer: ViewContainerRef;
  @ViewChild('miniOtpContainer', { read: ViewContainerRef }) otpContainer: ViewContainerRef;
  @ViewChild('miniOtpButton', { read: ViewContainerRef }) otpButtonContainer: ViewContainerRef;
  @ViewChild('miniOtp', { read: ElementRef }) miniOtpInput: ElementRef;

  //constants
  public readonly OTP_TIME = 30;

  //properties
  private notificationTarget : TwoFactorAuthentication;
  private contactVerify : string;
  private userIdentifier : string;
  private numOtpFields : number;
  public otpFields : number[];
  private status : boolean = false;
  private type : OtpType = OtpType.Default;

  //util
  public errorMessage : string;
  public contactVerifyMasked : string;
  public previosContactVerifyMaskedVal : string = '';
  public isExecuting : boolean = false;
  public OtpType = OtpType;

  //timer
  public isButtonLocked: boolean = false;
  public timeDisplay: string;
  public totalTimeInSeconds: number = this.OTP_TIME;
  private interval: any;

  //components
  private messageMetadata : any;
  @ViewChildren('otpInput') otpInputs!: QueryList<ElementRef>;

  //Mini OTP
  private miniOtpTitle : string = 'Código de seguridad';
  private miniOtpDescription : string = 'Enviar código de seguridad por:';
  private miniOtpMainEmail : string = '';
  private miniOtpMainPhone : string = '';
  public isMiniOtpCodeSectionOpen : boolean = false;
  private miniOtpRadioComponents : CtRadioComponent[] = [];
  private miniOtpButtonComponent : CtButtonComponent;
  public miniOtpIcon : string;
  public miniOtpError : string = '';
  public MINI_OTP_ERROR : string = 'Código incorrecto, intente de nuevo.';

  constructor(private cfr: ComponentFactoryResolver,
    private cdr : ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.createRange(this.numOtpFields);
    this.createMessageMetadata();
  }

  ngAfterViewInit(): void {
    if(this.type === OtpType.Mini){
      this.getContactInfoForMiniOtp();
    } 
  }

  private getContactInfoForMiniOtp() {
    this.authService.getUserPreviewContacts(this.authService.loggedUser.access_token).subscribe({
      next: (response: any) => {
        this.extractMainContactsFromContactInfoReq(response);
        this.setRadioComponentsToMiniOtp();
      }
    });
  }

  private setRadioComponentsToMiniOtp() {
    let metadata = this.getMetaData();
    metadata.models = [];
  
    this.addRadioComponentIfValid(metadata.models, 'Correo electrónico', this.miniOtpMainEmail, 'EMAIL');
    this.addRadioComponentIfValid(metadata.models, 'SMS', this.miniOtpMainPhone, 'PHONE');
  
    this.setMetaData(metadata);
    this.paintChildren(this.getMetaData(), this.otpContainer);
    this.miniOtpRadioComponents = this.getChildsByType(CtRadioComponent);
    this.paintMiniOtpButton();
  }

  private addRadioComponentIfValid(models: any[], label: string, value: string, idSuffix: string) {
    if (value) {
      models.push(this.createRadioComponent(label, value, idSuffix));
    }
  }

  private createRadioComponent(labelValue: string, value: string, idSuffix: string): any {
    let component = JSON.parse(JSON.stringify(radioComponent));
    component.controlProperties.labelValue = labelValue;
    component.controlProperties.value = value;
    component.controlProperties.id = component.controlProperties.id + idSuffix;
    component.controlProperties.modelId = idSuffix;
    component.controlActions = [this.getControlAction()];
    return component;
  }

  private getControlAction(): any {
    return {
      displayName: null,
      eventName: "onSelect",
      actionKey: null,
      type: "VIEW",
      action: "utl_setOtpModelFromRadioOnClickToMiniOtp",
      isAsync: false,
      actionParams: [
        this.getId()
      ],
      conditionParams: [],
      utilParams: [],
      preAction: null,
      postAction: null,
      params: [],
      actionsFlow: null,
      OperationType: null,
      Entity: null,
      Operation: "utl_setOtpModelFromRadioOnClickToMiniOtp",
      Endpoint: null
    };    
  }

  private paintMiniOtpButton() {
    this.otpButtonContainer.clear();
    const componentFactory = this.cfr.resolveComponentFactory(CtButtonComponent);
    const componentRef = this.otpButtonContainer.createComponent(componentFactory);
    const component: any = componentRef.instance;
    component.setMetaData(buttonComponent);
    this.miniOtpButtonComponent = component;
    (componentRef.instance as CtButtonComponent).clickTimer.subscribe(() => {
      this.miniOtpError = '';
      if(this.isButtonLocked) return;
      this.sendMiniOtpCode();
    });
  }

  private sendMiniOtpCode() {
    let isOneChecked = false;
    this.miniOtpRadioComponents.forEach((radioComponent: CtRadioComponent) => {
      if (radioComponent.checkboxInput.nativeElement.checked) {
        isOneChecked = true;
      }
    });
    if (!isOneChecked) return;

    this.isMiniOtpCodeSectionOpen = true;
    this.cdr.detectChanges();
    this.miniOtpIcon = 'assets/icons/Review.svg';
    this.sendCode();
  }

  public setOtpModelFromRadioOnClick(): void {
    this.miniOtpRadioComponents.forEach((radioComponent: CtRadioComponent) => {
      if (radioComponent.checkboxInput.nativeElement.checked) {
        let isEmail = radioComponent.getModelId() === 'EMAIL';
        this.setContactVerify(isEmail ? this.miniOtpMainEmail : this.miniOtpMainPhone);
        this.setNotificationTarget(isEmail ? TwoFactorAuthentication.EMAIL : TwoFactorAuthentication.PHONE);
        this.setUserIdentifier(this.authService.loggedUser.user.user_code);
      }
    });
  }

  public getMiniOtpSendMessage(): string {
    return `Ingrese el código enviado al ${this.notificationTarget === TwoFactorAuthentication.EMAIL ? 'correo' : ''} ${this.contactVerifyMasked}`;
  }

  public onMiniOtpChange(event: Event) {
    this.handleMiniOtpInput(event);
    const size : number = this.miniOtpInput.nativeElement.value.length;
    if(size === this.numOtpFields && this.status) return;
    if(size === this.numOtpFields) this.validateOtpCode();
  }

  handleMiniOtpInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.toUpperCase();
    if (value.length > 6) {
      value = value.substring(0, 6);
    }
    input.value = value;
  }

  private extractMainContactsFromContactInfoReq(response: any) {
    response.forEach((apiResponse: ApiResponseModel) => {
      apiResponse['Data'].forEach((data: any) => {
        let shouldContinue = true;
        data.ArrayEntities.List.some((entity: any) => {
          if (entity.Alias === 'IND_PRINCIPAL' && entity.Value === 'N') {
            shouldContinue = false;
            return true;
          }
          
          if (entity.Alias === 'DES_LOCALIZACION') {
            if (entity.Value.includes('@')) {
              this.miniOtpMainEmail = entity.Value;
            } else {
              this.miniOtpMainPhone = entity.Value;
            }
          }
          
          return false;
        });
      
        if (!shouldContinue) return;
      });
    });
  }

  private createMessageMetadata() {
    this.messageMetadata = {
      ctType: "CtMessage",
      controlProperties: {
          actionIcon: "",
          actionText: "",
          hidden: false,
          canBeClosed: false,
          size: CtMessageSize.large,
          style: CtMessageStyle.unicolor,
          type: CtMessageType.error,
          visualization: CtMessageVisualization.block,
          message: "",
          title: "",
          id: `CT_MESSAGE_DEF_OTP_${0}`
      },
      controlActions: [],
      models: []
    };
  }

  public setDataToOtp(contactVerify : string, notificationTarget: string, userIdentifier : string): void {
    this.setContactVerify(contactVerify);
    this.setNotificationTarget(notificationTarget === 'EMAIL' ? TwoFactorAuthentication.EMAIL : TwoFactorAuthentication.PHONE);
    this.setUserIdentifier(userIdentifier);
  }

  public createRange(num: number): void {
    this.otpFields = Array.from({ length: num }, (_, i) => i);
  }

  public sendCode(): void {
    if(this.isButtonLocked || !this.getContactVerify()) return;
    if(!(this.type === OtpType.Mini)) this.messageContainer.clear();

    let notificationModel = new OtpNotificationModel();
    notificationModel.contactVerify = this.contactVerify;
    notificationModel.NotificationTarget = this.notificationTarget;
    notificationModel.UserIdentifier = this.userIdentifier;

    if(this.notificationTarget === TwoFactorAuthentication.PHONE){
      notificationModel.contactVerify = notificationModel.contactVerify
        .slice(-Math.ceil(notificationModel.contactVerify.length / 2));
    }

    this.executeOtpDispatch(notificationModel);
  }

  private executeOtpDispatch(notificationModel: OtpNotificationModel) {
    this.authService.sendOtpCode(notificationModel).subscribe({
      next: () => {
        this.startCountdown();
      },
      error: (err) => {
        this.errorMessage = err.description;
        this.buildMessage();
      }
    });
  }

  /**
   * The `moveFocus` function is used to move the focus to the next input element in an OTP (One-Time
   * Password) input field when the current input element reaches its maximum length.
   * @param {KeyboardEvent} event 
   * @param {number} index 
   */
  public moveFocus(event: KeyboardEvent, index: number): void {
    const inputElement = event.target as HTMLInputElement;
    const maxLength = parseInt(inputElement.getAttribute('maxlength') || '0', 10);
    const inputValue = inputElement.value;

    if (inputValue.length >= maxLength && index < this.otpInputs.length - 1) {
      const nextInput = this.otpInputs.toArray()[index + 1].nativeElement as HTMLInputElement;
      nextInput.focus();
    } else if (inputValue.length === 0 && index > 0) {
      const previousInput = this.otpInputs.toArray()[index - 1].nativeElement as HTMLInputElement;
      previousInput.focus();
    }
  }

  public validateOtpCode(): void {
    let otpModel : OtpModel = new OtpModel();
    otpModel.userCode = this.userIdentifier;
    otpModel.otp = this.getOtpCodeFromInput();
    if(this.type === OtpType.Mini) otpModel.otp = this.miniOtpInput.nativeElement.value;

    this.executeOtpValidation(otpModel);
  }

  private executeOtpValidation(otpModel: OtpModel) {
    if(this.isExecuting) return;
    else this.isExecuting = true;
    if(!(this.type === OtpType.Mini)) this.messageContainer.clear();
    this.authService.validateOtpCode(otpModel).subscribe({
      next: () => {
        this.executePostAction();
        this.setStatus(true);
        if(this.type === OtpType.Mini) {
          this.miniOtpIcon = 'assets/icons/Good.svg';
          this.isExecuting = false;
          this.miniOtpError = '';
          this.miniOtpButtonComponent.setDisabled(true);
          this.isButtonLocked = true;
          this.miniOtpInput.nativeElement.disabled = true;
        }
      },
      error: (err) => {
        this.isExecuting = false;
        this.setStatus(false);
        this.errorMessage = err.description;
        if(!(this.type === OtpType.Mini)) this.buildMessage();
        if(this.type === OtpType.Mini){
          this.miniOtpIcon = 'assets/icons/Canceled.svg';
          this.miniOtpError = this.MINI_OTP_ERROR;
        }
      }
    });
  }

  /**
   * The function "executePostAction" checks if there is a post action event and executes the
   * corresponding action.
   */
  private executePostAction() {
    let action : Action = this.getEvent('onPostAction');
    if (action) {
      this.executeAction2(action);
    }
  }

  /**
   * Concatenates the values of all otp fields and returns the resulting otp.
   */
  public getOtpCodeFromInput(): string {
    let concatenatedString = '';
    this.otpInputs.forEach((input: ElementRef) => {
      const inputValue: string = input.nativeElement.value;
      concatenatedString += inputValue;
    });
    return concatenatedString.toUpperCase();
  }

  /* 
    * The `startCountdown()` function is responsible for starting the countdown timer for the OTP
    * (One-Time Password) code. It sets the `isButtonLocked` property to `true` to prevent multiple
    * clicks on the button, and then uses `setInterval()` to decrement the `totalTimeInSeconds` property
    * every second. 
  */
  private startCountdown(): void {
    this.isButtonLocked = true;
    if(this.type === OtpType.Mini) {
      this.miniOtpButtonComponent.setDisabled(this.isButtonLocked);
    }
    this.interval = setInterval(() => {
      this.totalTimeInSeconds--;

      if (this.totalTimeInSeconds <= 0) {
        this.stopCountdown();
      } else {
        this.updateTimeDisplay();
      }
    }, 1000);
  }

  private stopCountdown(): void {
    clearInterval(this.interval);
    this.totalTimeInSeconds = this.OTP_TIME;
    this.isButtonLocked = false;
    if(this.type === OtpType.Mini) {
      if(this.status){
        this.isButtonLocked = true;
        this.timeDisplay = '';
        return;
      }
      this.miniOtpButtonComponent.setDisabled(this.isButtonLocked);
    } 
    this.timeDisplay = '';
  }

  private updateTimeDisplay(): void {
    const minutes = Math.floor(this.totalTimeInSeconds / 60);
    const seconds = this.totalTimeInSeconds % 60;
    this.timeDisplay = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    this.activeOTPErrorMessage();

  }

  private activeOTPErrorMessage(): void {
    if (this.previosContactVerifyMaskedVal !== this.contactVerifyMasked && this.totalTimeInSeconds > 0) {
      this.errorMessage = 'Lo sentimos, no es posible solicitar códigos de verificación reiteradamente. Le solicitamos que aguarde un momento antes de intentar enviar otro. Agradecemos su comprensión.';
      if(this.type !== OtpType.Mini) this.buildMessage();
    }
    if (this.totalTimeInSeconds === 1) {
      setTimeout(() => {
        if(!(this.type === OtpType.Mini)) this.messageContainer.clear();
      }, 1000);
    }
  }

  /**
   * Builds error messages
   */
  private buildMessage(): void {
    this.messageMetadata.controlProperties.message = this.errorMessage;
    this.getMetaData().models = [this.messageMetadata];
    this.paintChildren(this.getMetaData(), this.messageContainer);
  }

  /**
   * Applies a mask to a contact string, replacing characters with asterisks to hide
   * sensitive information.
   */
  private applyMaskToContact(contact: string): void {
    if (this.previosContactVerifyMaskedVal !== '') {
      this.previosContactVerifyMaskedVal = this.contactVerifyMasked;
    }
    if (contact.includes('@')) {
      const [username, domain] = contact.split('@');
      const maskedUsername = `${username.charAt(0)}${'*'.repeat(Math.max(0, Math.floor((username.length - 2) / 2)))}${username.slice(-1)}`;
      const maskedDomain = `${domain.slice(0, 3)}${'*'.repeat(Math.max(0, Math.floor((domain.length - 6) / 2)))}${domain.slice(-3)}`;
      this.contactVerifyMasked = `${maskedUsername}@${maskedDomain}`;
    } else {
      const maskedNumber = `${contact.slice(0, 2)}${'*'.repeat(Math.max(0, contact.length - 4))}${contact.slice(-2)}`;
      this.contactVerifyMasked = maskedNumber;
    }
    if (this.previosContactVerifyMaskedVal === "") {
      this.previosContactVerifyMaskedVal = this.contactVerifyMasked;
    }
  }

  ngOnDestroy(): void {
    this.stopCountdown();
    this.setStatus(false);
  }

  //generate getters and setters
  getNotificationTarget() : TwoFactorAuthentication { return this.notificationTarget; }
  getContactVerify() : string { return this.contactVerify; }
  getUserIdentifier() : string { return this.userIdentifier; }
  getNumOtpFields() : number { return this.numOtpFields; }
  getStatus() : boolean { return this.status; }
  getType() : OtpType { return this.type; }
  getMiniOtpTitle() : string { return this.miniOtpTitle; }
  getMiniOtpDescription() : string { return this.miniOtpDescription; }

  setNotificationTarget(notificationTarget : TwoFactorAuthentication) { this.notificationTarget = notificationTarget; }
  setContactVerify(contactVerify : string) {
    this.contactVerify = contactVerify;
    this.applyMaskToContact(contactVerify);
  }
  setUserIdentifier(userIdentifier : string) { this.userIdentifier = userIdentifier; }
  setNumOtpFields(numOtpFields : number) { this.numOtpFields = numOtpFields; }
  setStatus(status : boolean) { this.status = status; }
  setType(type : OtpType) { 
    this.type = type;
   }
  setMiniOtpTitle(miniOtpTitle : string) { this.miniOtpTitle = miniOtpTitle; }
  setMiniOtpDescription(miniOtpDescription : string) { this.miniOtpDescription = miniOtpDescription; }
}
